// src/scenes/groupOfficials/approvalForm.jsx
import React, { useMemo } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  Alert,
  Divider,
} from "@mui/material";

const ApprovalSettingsForm = ({
  open,
  onClose,
  onSubmit,
  saving,
  errorMsg,
  users,
  draft,
  setDraft,
}) => {
  const userOptions = useMemo(() => {
    return (users || [])
      .filter((u) => u?.isActive !== false)
      .map((u) => {
        const name = [u.firstName, u.lastName].filter(Boolean).join(" ").trim();
        return {
          id: String(u.id),
          label: name || u.email || `User #${u.id}`,
          meta: u.role ? ` • ${u.role}` : "",
        };
      })
      .sort((a, b) => a.label.localeCompare(b.label));
  }, [users]);

  const handleApproverChange = (value) => {
    setDraft((prev) => ({
      ...prev,
      approverId: value ? String(value) : "",
    }));
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Set Maker-Checker Approver</DialogTitle>

      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Choose who approves records for this process/table.
        </Typography>

        {errorMsg ? (
          <Alert severity="error" sx={{ mb: 2 }}>
            {errorMsg}
          </Alert>
        ) : null}

        <Divider sx={{ mb: 2 }} />

        <Box sx={{ display: "grid", gap: 2 }}>
          <Box>
            <Typography fontWeight={800}>Process</Typography>
            <Typography variant="body2" sx={{ opacity: 0.85 }}>
              {draft?.tableLabel || draft?.tableName || ""}
            </Typography>
            <Typography variant="caption" sx={{ opacity: 0.7 }}>
              {draft?.tableName || ""}
            </Typography>
          </Box>

          <FormControl fullWidth disabled={saving}>
            <InputLabel id="approver-label">Approver</InputLabel>
            <Select
              labelId="approver-label"
              label="Approver"
              value={draft?.approverId ? String(draft.approverId) : ""}
              onChange={(e) => handleApproverChange(e.target.value)}
            >
              <MenuItem value="">
                <em>— Select Approver —</em>
              </MenuItem>
              {userOptions.map((u) => (
                <MenuItem key={u.id} value={u.id}>
                  {u.label}
                  {u.meta}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={saving}>
          Cancel
        </Button>
        <Button variant="contained" onClick={onSubmit} disabled={saving}>
          {saving ? "Saving..." : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ApprovalSettingsForm;